import type {ClosetItem} from '@/types';
import styles from './Card.module.css';

interface GridCardProps {
  item: ClosetItem;
  showMemberBadge?: boolean;
  memberName?: string;
  onClick?: () => void;
}

export function GridCard({item, showMemberBadge, memberName, onClick}: GridCardProps) {
  return (
    <div className={styles.gridCard} onClick={onClick}>
      <div className={styles.gridImage}>
        <span className={styles.gridEmoji}>{item.emoji}</span>
        {showMemberBadge && memberName && (
          <span className={styles.badge}>{memberName}</span>
        )}
      </div>
      <div className={styles.gridInfo}>
        <div className={styles.brand}>{item.brand}</div>
        <div className={styles.productName}>{item.name}</div>
        <div className={styles.gridRow}>
          <span className={styles.price}>${formatPrice(item.price)}</span>
          <span className={styles.date}>{formatDate(item.date)}</span>
        </div>
      </div>
    </div>
  );
}

function formatPrice(price: number): string {
  return price.toLocaleString('en-US', {
    minimumFractionDigits: price % 1 ? 2 : 0,
  });
}

function formatDate(dateStr: string): string {
  return new Date(dateStr + 'T00:00:00').toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}
